import { useToast } from "@chakra-ui/react";

export default function useEntityProfileToast() {
  return useToast({ position: "top-right" });
}
